import type { FC } from 'react';
import React, { useContext } from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Flex from '@atlaskit/primitives/components/flex';
// oxlint-disable-next-line @atlaskit/design-system/no-emotion-primitives
import { xcss } from '@atlaskit/primitives/xcss';

import { UNSAFE_expValNoExposure } from '@confluence/feature-experiments';
import { ContentIcon as ContentIconCombined } from '@confluence/icons/entry-points/ContentIcon.ts';
import { ThirdPartyIcon } from '@confluence/icons/entry-points/ThirdPartyIcon.ts';

import { PageCardContext } from '../PageCardContext.ts';

const iconBorderStyles = xcss({
	borderColor: 'color.border',
	borderStyle: 'solid',
	borderRadius: 'radius.small',
	borderWidth: 'border.width',
	height: '32px',
	width: '32px',
});

// The ADS tile radius, as on the 3P logos: a first step towards ADS styling for Confluence's icons
const tileRadiusStyles = xcss({
	borderRadius: 'radius.tile',
});

export const ContentIcon: FC = () => {
	const {
		id,
		type,
		title: { emoji },
		appearance,
		subType,
		thirdParty,
	} = useContext(PageCardContext);
	const isCompactEndOfPage = appearance === 'compact-end-of-page';

	return (
		<Flex
			alignItems="center"
			justifyContent="center"
			xcss={[
				// 3P logos are ADS tiles with their own border, the size of this box
				!isCompactEndOfPage && !thirdParty && iconBorderStyles,
				// Without exposure, as page cards also show outside Recent
				UNSAFE_expValNoExposure('confluence_recent_3p_activities', 'isEnabled', false) &&
					tileRadiusStyles,
			]}
		>
			{thirdParty ? (
				<ThirdPartyIcon thirdPartyId={id} size="medium" />
			) : (
				<ContentIconCombined type={type} emoji={emoji} subType={subType} />
			)}
		</Flex>
	);
};
